import { api } from '../services';

// @todo: e se a pessoa tentar cadastrar o mesmo email para empresas diferentes?
async function saveLead(leadData) {
  const response = await api.saveLead(leadData);

  if (!response.ok) {
    return {
      success: false,
      data: (response.data && response.data.errors) || [],
    };
  }
  const {data: { attributes }} = response.data;

  const lead = {
    name: attributes.name,
    email: attributes.email,
    company: attributes.company,
    jobRole: attributes.jobRole,
    interests: attributes.interests,
  };

  return { success: true, data: lead };
}

export default saveLead;
